import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppDataModule } from '@unpispas/upp-data';

import { UppTopBarComponent } from '../components/topbar/upp-topbar';

@NgModule({
    declarations: [
        UppTopBarComponent
    ],
    imports: [
        CommonModule, 
        IonicModule,
        UppBaseModule,
        UppWdgtModule,
        UppDataModule
    ],
    exports: [
        UppTopBarComponent
    ],
    providers: [],  
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]  
})
export class FeatureTopbarModule {}

